module.exports = __webpack_public_path__ + "static/media/04-galeria-05-restaurante-palacio@2x.55177902.jpg";